export default {
  // 页面标题
  'pages.salesOverview.title': '销售总览',
  'pages.salesOverview.subTitle': '房产与车位销售数据统计分析',
  
  // 统计卡片
  'pages.salesOverview.stats.houseCount': '房屋数量',
  'pages.salesOverview.stats.parkingCount': '车位数量',
  'pages.salesOverview.stats.houseSales': '房屋销售额',
  'pages.salesOverview.stats.parkingSales': '车位销售额',
  'pages.salesOverview.stats.houseReserve': '房屋预定额',
  'pages.salesOverview.stats.parkingReserve': '车位预定额',
  'pages.salesOverview.stats.totalSales': '总销售额',
  'pages.salesOverview.stats.totalReserve': '总预定额',
  
  // 图表标题
  'pages.salesOverview.chart.monthlyTrend': '近12个月销售趋势',
  'pages.salesOverview.chart.houseMonthlyTrend': '房产月度销售趋势',
  'pages.salesOverview.chart.parkingMonthlyTrend': '车位月度销售趋势',
  'pages.salesOverview.chart.statusDistribution': '房屋状态分布',
  'pages.salesOverview.chart.parkingStatusDistribution': '车位状态分布',
  'pages.salesOverview.chart.salesComparison': '房屋与车位销售对比',
  
  // 图表图例
  'pages.salesOverview.legend.houseSales': '房屋销售额',
  'pages.salesOverview.legend.houseReserve': '房屋预定额',
  'pages.salesOverview.legend.parkingSales': '车位销售额',
  'pages.salesOverview.legend.parkingReserve': '车位预定额',
  'pages.salesOverview.legend.salesWithCurrency': '销售额(₱)',
  'pages.salesOverview.legend.reserveWithCurrency': '预定额(₱)',
  
  // 表格
  'pages.salesOverview.table.houseStatus': '房屋状态统计',
  'pages.salesOverview.table.parkingStatus': '车位状态统计',
  'pages.salesOverview.table.columns.status': '状态',
  'pages.salesOverview.table.columns.month': '月份',
  'pages.salesOverview.table.columns.salesWithCurrency': '销售额(₱)',
  'pages.salesOverview.table.columns.reserveWithCurrency': '预定额(₱)',
  'pages.salesOverview.table.columns.trend': '趋势',
  'pages.salesOverview.table.columns.count': '数量',
  'pages.salesOverview.table.columns.amount': '金额',
  'pages.salesOverview.table.columns.percentage': '占比',
  'pages.salesOverview.table.houseMonthlyData': '房产月度数据',
  'pages.salesOverview.table.parkingMonthlyData': '车位月度数据',
  'pages.salesOverview.label.amount': '金额',
  'pages.salesOverview.label.reserve': '预定',
  'pages.salesOverview.status.fallback': '状态{status}',
  'pages.salesOverview.common.emptyValue': '—',
  
  // 货币符号
  'pages.salesOverview.currency.symbol': '₱',
  
  // 单位
  'pages.salesOverview.unit.count': '套',
  'pages.salesOverview.unit.parkingCount': '个',
  'pages.salesOverview.unit.month': '月',
  
  // 加载状态
  'pages.salesOverview.loading': '数据加载中...',
  'pages.salesOverview.noData': '暂无数据',
  
  // 错误信息
  'pages.salesOverview.error.loadData': '数据加载失败',
  'pages.salesOverview.error.retry': '重试',
};
